import { Route, routes } from '@router';

type ModelItem = Omit<Route, 'sub'>;

export const useModel = (): ModelItem[] => {
  return routes.dashboard.sub ? Object.values(routes.dashboard.sub) : [];
};
